import axios from 'axios';
import config from '../config';
import {JsonHeaders} from '../constants';

export default {
    getSocksProxy(id) {
        return axios.get(config.publicPath + 'socks/' + id, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    getSocksProxies(currentPage, perPage, orderField, orderDirection, user_id, ip) {
        let parameters = {
            _page: currentPage,
            itemsPerPage: perPage,
            "user.id": user_id,
            ip: ip
        };
        parameters['order[' + orderField +']'] = orderDirection;
        return axios.get(config.publicPath + 'socks', {
            params: parameters,
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    getSocksProxySelect() {
        return axios.get(config.publicPath + 'socks', {
            params: {'groups[]': 'select', 'pagination': false},
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    createSocksProxy(formData) {
        return axios.post(config.publicPath + 'socks', formData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    uploadSocksProxies(data) {
        return axios.post(config.publicPath + 'add-socks-proxies', data, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            },
        });
    },
    updateSocksProxy(id, formData) {
        return axios.put(config.publicPath + 'socks/' + id, formData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    deleteSocksProxy(id) {
        return axios.delete(config.publicPath + 'socks/' + id, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    checkSocksProxy(id) {
        return axios.get(config.publicPath + 'socks/check/' + id, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    resetSocksProxiesActivity(userId = null) {
        return axios.get(config.publicPath + 'socks/reset-activity', {
            params: {userId: userId},
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    deleteInactiveSocks(userId = null) {
        return axios.get(config.publicPath + 'socks/delete-inactive', {
            params: {userId: userId},
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    deleteAllSocks(userId = null) {
        return axios.get(config.publicPath + 'socks/delete-all', {
            params: {userId: userId},
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    }
}
